/*************************************************/
/* HEADER (DEBUG VERSION)                        */
/*************************************************/

export function header() {
    let prevScrollPos = window.pageYOffset;
    let isAtTop = true;
    let headerLocked = false;

    const header = document.querySelector(".header");
    const top = window.innerWidth <= 768 ? "-90px" : "-130px";
    const stickyHeaderClass = "header-sticky";
    const stickyLogo = document.querySelector(".logo--sticky");
    const fixedLogo = document.querySelector(".logo--fixed");

    let ticking = false;

    function onScroll() {
        updateHeaderLock();

        if (headerLocked) {
            header.style.top = "0";
            prevScrollPos = window.scrollY;
            ticking = false;
            return;
        }

        const currentScrollPos = window.scrollY;

        if (prevScrollPos < 0) prevScrollPos = 0;

        // SCROLLING DOWN → hide header only if NOT locked
        if (!headerLocked && prevScrollPos < currentScrollPos) {

            if (header.style.top !== top) {
                header.style.top = top;
            }

            isAtTop = false;
        }
        // SCROLLING UP → show header
        else {
            if (!isAtTop && !header.classList.contains(stickyHeaderClass)) {
                activateStickyHeader();
            }

            if (currentScrollPos > 0 && header.style.top !== "0") {
                header.style.top = "0";
            }
        }

        // RESET AT TOP
        if (currentScrollPos <= 0 && !isAtTop) {
            resetHeader();
        }

        prevScrollPos = currentScrollPos;
        ticking = false;
    }

    function activateStickyHeader() {
        header.classList.add(stickyHeaderClass);
        stickyLogo.style.display = "block";
        fixedLogo.style.display = "none";
    }

    function resetHeader() {
        header.classList.remove(stickyHeaderClass);
        stickyLogo.style.display = "none";
        fixedLogo.style.display = "block";
        isAtTop = true;
    }

    window.addEventListener("scroll", () => {
        if (!ticking) {
            window.requestAnimationFrame(onScroll);
            ticking = true;
        }
    });

    function updateHeaderLock() {
        const menuOpen = document.querySelector(".menu-nav__wrap-open") !== null;

        if (menuOpen) {
            headerLocked = true;
            header.style.top = "0";
        } else {
            headerLocked = false;
        }
    }
}
